import { render, staticRenderFns } from "./WidgetsPage.vue?vue&type=template&id=a1d58418&scoped=true&lang=html&"
import script from "./WidgetsPage.vue?vue&type=script&lang=js&"
export * from "./WidgetsPage.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsPage.vue?vue&type=style&index=0&id=a1d58418&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d58418",
  null
  
)

export default component.exports